import { render } from "./InvoicesReturnTable.vue?vue&type=template&id=5f99a031"
import script from "./InvoicesReturnTable.vue?vue&type=script&lang=js"
export * from "./InvoicesReturnTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__